import * as React from 'react';
import {useEffect, useState} from 'react';
import Api from "../../Api/api";
import {toast} from "react-toastify";
import {formatDate} from "../../helper/formatDate";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ClipLoader} from "react-spinners";
import {AES, enc} from "crypto-js";
import {useStateValue} from "../../states/StateProvider";
import Pagination from "../../components/pagination";
import {
    HiCheckCircle, HiChevronDown, HiChevronUp, HiExclamationCircle, HiXCircle
} from "react-icons/hi";
import ExcelFormatWVHistory from "../firmenprojekte/partial/excelFormatWVHistory";
import DatePicker from "react-datepicker";
import {ArrowTopRightOnSquareIcon} from '@heroicons/react/24/outline';
import {format} from 'date-fns';

const MailHistory = () => {
    const [hasFilter, setHasFilter] = useState(false);
    const [sortKey, setSortKey] = useState('wv_datum');
    const [sortAsc, setSortAsc] = useState(true);
    const [showActive, setShowActive] = useState(true);
    const [{
        secretKey, pageWvHistory, filterWVHistory, filterIDWVHistory
    }, dispatch] = useStateValue();

    const url = '/sp_getDataWVHistorie'

    const WVHistorieHeaders = [{
        id: 1, column: 4, title: 'WV-Datum', dataKey: 'wv_datum'
    }, {
        id: 2, column: 3, title: 'Firma-Kurz', dataKey: 'firma'
    }, {
        id: 3, column: 6, title: 'Berater', dataKey: 'berater'
    }, {
        id: 4, column: 2, title: 'Erfasst am', dataKey: 'erfasst_am'
    }, {
        id: 5, column: 1, title: 'Erfasst von', dataKey: 'erfasst_von'
    }, {
        id: 6, column: 5, title: 'Bemerkung', dataKey: 'bemerkung'
    }]

    const count = WVHistorieHeaders.length

    const sortableFields = [1, 2, 3, 4, 5, 6, 7]
    const searChableFields = [1, 2, 3, 4, 5, 6]
    const [data, setData] = useState([])
    const [sortedData, setSortedData] = useState([])
    const [noDataFound, setNoDataFound] = useState(false)
    const [loading, setLoading] = useState(true)
    const [rows, setRows] = useState('10');
    const navigate = useNavigate();
    const location = useLocation();
    const [total, setTotal] = useState(0);
    let PageSize = rows;

    const handleSort = (key) => {
        setSortAsc(sortKey === key ? !sortAsc : true);
        setSortKey(key);
    };

    useEffect(() => {
        try {
            const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
            const User = JSON.parse(decryptedBytes.toString(enc.Utf8))
            if (User.role !== 'Internal') {
                location.replace('/')
            } else {
                // Check if filter has any actual non-empty values
                const hasActiveFilters = filterWVHistory && Object.values(filterWVHistory).some(val =>
                    val !== null && val !== undefined && val !== ''
                );

                const delayQuery = setTimeout(async () => {
                    setLoading(true)
                    let data = new FormData()
                    data.append('perPage', rows)
                    data.append('page', pageWvHistory)
                    data.append('sortMethod', sortKey && sortAsc ? 'asc' : 'desc')
                    data.append('sortColumn', sortKey ? WVHistorieHeaders.find(h => h.dataKey === sortKey)?.id : '')
                    data.append('filterID', JSON.stringify(filterIDWVHistory))
                    data.append('filter', JSON.stringify(filterWVHistory))
                    data.append('showActive', showActive ? 1 : 0)

                    Api().post(url, data).then(res => {
                        setData(res.data)
                        Object.values(res.data[0]).map(r => {
                            if (r === '0') {
                                setNoDataFound(true)
                            } else {
                                setNoDataFound(false)
                            }
                        })

                        setTotal(res.data[0]?.total?? 0)
                        setLoading(false)
                    }).catch(e => {
                        toast.error('etwas ist schief gelaufen!')
                    })
                }, hasActiveFilters ? 1500 : 0)

                return () => clearTimeout(delayQuery)
            }
        } catch (e) {
            window.location.replace('/anmeldung')
        }

    }, [pageWvHistory, rows, sortKey, sortAsc, filterWVHistory, filterIDWVHistory, showActive]);

    useEffect(() => {
        // Check all filter keys used by WV-Historie
        const relevantKeys = ['a', 'c', 'd', 'e', 'f', 'g'];
        const hasActiveFilters = relevantKeys.some(key => {
            const val = filterWVHistory[key];
            return val !== null && val !== undefined && val !== '';
        });

        setHasFilter(!hasActiveFilters);
    }, [filterWVHistory]);

    useEffect(() => {
        const sorted = [...data].sort((a, b) => {
            if (!sortKey) return 0;
            const valA = a[sortKey];
            const valB = b[sortKey];
            if (valA < valB) return sortAsc ? -1 : 1;
            if (valA > valB) return sortAsc ? 1 : -1;
            return 0;
        });
        setSortedData(sorted);
    }, [data, sortKey, sortAsc]);

    function setPageStates(e) {
        dispatch({type: "SET_PAGE_WVHISTORY", item: 1})
        setRows(e.target.value)
    }

    function enableFilter(id, column, val) {
        // Get current filter value to check if it has actually changed
        const currentValue = getFilterValue(id);

        // Normalize values: treat null, undefined, and empty string as equivalent
        const normalizedCurrent = currentValue == null || currentValue === '' ? null : currentValue;
        const normalizedNew = val == null || val === '' ? null : val;

        // Only proceed if the value has actually changed
        if (normalizedCurrent === normalizedNew) {
            return;
        }

        // Use the normalized value for storage to maintain consistency
        const valueToStore = normalizedNew;

        dispatch({type: "SET_PAGE_WVHISTORY", item: 1})

        // Backend expects: filterID.a === 2 → $filtErsteller (Erfasst von)
        // Backend expects: filterID.c === 3 → $filtInhalt (Bemerkung)
        // Backend expects: filterID.d === 5 → $filtFirma (Firma)
        // Backend expects: filterID.e === 6 → $filtBerater (Berater)
        // Backend expects: filterID.f === 1 → $filterErfasstAm (Erfasst am)
        // Backend expects: filterID.g === 4 → $filterwvDate (WV-Datum)

        if (id === 1) { // WV-Datum
            dispatch({type: "SET_SORTWVHISTORYFILTER", item: {...filterWVHistory, g: valueToStore}})
            dispatch({type: "SET_SORTWVHISTORYFILTERID", item: {...filterIDWVHistory, g: 4}})
        }
        if (id === 2) { // Firma-Kurz
            dispatch({type: "SET_SORTWVHISTORYFILTER", item: {...filterWVHistory, d: valueToStore}})
            dispatch({type: "SET_SORTWVHISTORYFILTERID", item: {...filterIDWVHistory, d: 5}})
        }
        if (id === 3) { // Berater
            dispatch({type: "SET_SORTWVHISTORYFILTER", item: {...filterWVHistory, e: valueToStore}})
            dispatch({type: "SET_SORTWVHISTORYFILTERID", item: {...filterIDWVHistory, e: 6}})
        }
        if (id === 4) { // Erfasst am
            dispatch({type: "SET_SORTWVHISTORYFILTER", item: {...filterWVHistory, f: valueToStore}})
            dispatch({type: "SET_SORTWVHISTORYFILTERID", item: {...filterIDWVHistory, f: 1}})
        }
        if (id === 5) { // Erfasst von
            dispatch({type: "SET_SORTWVHISTORYFILTER", item: {...filterWVHistory, a: valueToStore}})
            dispatch({type: "SET_SORTWVHISTORYFILTERID", item: {...filterIDWVHistory, a: 2}})
        }
        if (id === 6) { // Bemerkung
            dispatch({type: "SET_SORTWVHISTORYFILTER", item: {...filterWVHistory, c: valueToStore}})
            dispatch({type: "SET_SORTWVHISTORYFILTERID", item: {...filterIDWVHistory, c: 3}})
        }
    }

    const getFilterValue = (id) => {
        switch (id) {
            case 1: // WV-Datum
                return filterWVHistory.g;
            case 2: // Firma-Kurz
                return filterWVHistory.d;
            case 3: // Berater
                return filterWVHistory.e;
            case 4: // Erfasst am
                return filterWVHistory.f;
            case 5: // Erfasst von
                return filterWVHistory.a;
            case 6: // Bemerkung
                return filterWVHistory.c;
            default:
                return null;
        }
    };

    const getRowColor = (item) => {
        const currentDate = new Date();
        const itemDate = new Date(item.wv_datum);

        // Störfall always gets red background (highest priority)
        if (item.bemerkung && item.bemerkung.toLowerCase().includes('störfall')) {
            return "bg-cancel";
        }

        // Inactive WV entries get gray background
        if (item.aktiv === 0 || item.aktiv === '0' || item.aktiv === false) {
            return "bg-gray-200";
        }

        // Active entries follow date-based color logic
        if (itemDate > currentDate) {
            return "bg-complete";
        }
        if (itemDate < currentDate) {
            return "bg-pending";
        }
        return "";
    };

    const getStatusIcon = (item) => {
        const currentDate = new Date();
        const itemDate = new Date(item.wv_datum);

        if (item.bemerkung && item.bemerkung.toLowerCase().includes('störfall')) {
            return <HiXCircle size={20} className="text-red font-bold"/>;
        }
        if (itemDate > currentDate) {
            return <HiCheckCircle size={20} className="text-green font-bold"/>;
        }
        if (itemDate < currentDate) {
            return <HiExclamationCircle size={20} style={{color: "#FFA500"}}/>;
        }
        return null;
    };

    function clearFilters() {
        const resetFilters = Object.keys(filterWVHistory).reduce((acc, key) => {
            acc[key] = null;
            return acc;
        }, {});

        const resetFilterIDs = Object.keys(filterIDWVHistory).reduce((acc, key) => {
            acc[key] = null;
            return acc;
        }, {});

        dispatch({
            type: "SET_SORTWVHISTORYFILTER",
            item: resetFilters
        });

        dispatch({
            type: "SET_SORTWVHISTORYFILTERID",
            item: resetFilterIDs
        });
    }

    return (<div className='dashboardContainer'>
            <div className='flex justify-start items-center content-center pb-5'>
                <h2 className='text-2xl lg:text-left'> WV-Historie</h2>
            </div>
            <div className='flex flex-col p-10 pt-5 bg-white'>
                {loading ? <div className='centerItemsAbsolute'>
                    <ClipLoader size={'40px'} color={'black'}/>
                </div> : <>
                    <div className="bg-white pt-3 pb-1 lg:flex sm:block mb-3">
                        <ExcelFormatWVHistory all url={url} count={count} rows={rows} title={'Excel Export'}
                                              loading={loading}
                                              len={data?.length}/>
                        <ExcelFormatWVHistory Gesamt url={url} count={count} rows={rows} title={'Excel Export Gesamt'}
                                              loading={loading}
                                              len={data?.length}/>
                        <button disabled={hasFilter} onClick={clearFilters}
                                className={`${hasFilter && 'hideDiv bg-white text-text'} ${loading ? 'hideDiv' : ''} mx-auto justify-center w-52 rounded-md border border-offWhite shadow-sm px-4 opacity-80 py-2 bg-cancel text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                        >
                            {!hasFilter ? 'Such-Filter zurücksetzen' : 'Kein Suche Filter'}
                        </button>
                        <div className="flex items-center ml-4">
                            <label className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={showActive}
                                    onChange={(e) => setShowActive(e.target.checked)}
                                    className="mr-2 h-4 w-4 text-mainBlue focus:ring-mainBlue border-gray-300 rounded"
                                />
                                <span className="text-sm font-medium text-gray-700">Aktive</span>
                            </label>
                        </div>
                    </div>
                    <div className="overflow-y-auto w-full" style={{maxHeight: '60vh'}}>
                        <table className='w-full bg-white rounded' style={{fontSize: "14px", tableLayout: 'fixed', borderCollapse: "separate", borderSpacing: '0 6px'}}>
                            <thead>
                            <tr className="bg-gray-100">
                                <th 
                                    style={{width: '5%'}}
                                    className="px-1 py-2 text-center text-gray-700 font-semibold"
                                >
                                    <div className="flex items-center justify-start gap-1">
                                        <span style={{lineHeight: "1.25", fontSize: "0.9rem"}}></span>
                                    </div>
                                </th>
                                {WVHistorieHeaders?.map((header, index) => {
                                    const widths = ['5.625%', '24.1875%', '10%', '6%', '15%', '34.1875%'];
                                    
                                    return (
                                    <th 
                                        key={header.id} 
                                        onClick={() => handleSort(header.dataKey)}
                                        style={{width: widths[index]}}
                                        className="px-1 py-2 text-center text-gray-700 font-semibold cursor-pointer select-none"
                                    >
                                        <div className="flex items-center justify-start gap-1">
                                            <span style={{lineHeight: "1.25", fontSize: "0.9rem"}}>{header.title}</span>
                                            <div className="flex flex-col items-center leading-none">
                                                <HiChevronUp
                                                    className={`h-3 w-3 ${sortKey === header.dataKey && sortAsc ? "text-black" : "text-whiteDark"}`}
                                                />
                                                <HiChevronDown
                                                    className={`h-3 w-3 ${sortKey === header.dataKey && !sortAsc ? "text-black" : "text-whiteDark"}`}
                                                />
                                            </div>
                                        </div>
                                        <span
                                            className={`widervolage-history-suche ${!(searChableFields.includes(header.id)) && 'hideDiv'}`}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            {header.id === 1 || header.id === 4 ? (
                                                <DatePicker
                                                    locale="de"
                                                    dateFormat="MM/yyyy"
                                                    showMonthYearPicker
                                                    showFullMonthYearPicker
                                                    placeholderText="Monat wählen"
                                                    selected={getFilterValue(header.id) ? new Date(getFilterValue(header.id).split('.').reverse().join('-')) : null}
                                                    onChange={(date) => {
                                                        if (!date) {
                                                            enableFilter(header.id, header.column, null);
                                                            return;
                                                        }

                                                        const formatted = `01.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
                                                        enableFilter(header.id, header.column, formatted);
                                                    }}
                                                    className="w-full h-2 px-2 py-3 search mb-4 rounded-md border border-gray-300"
                                                    isClearable
                                                />
                                            ) : (
                                                <input
                                                    className="w-full h-2 px-2 py-3 search mb-4"
                                                    type="text"
                                                    maxLength="50"
                                                    value={getFilterValue(header.id) || ''}
                                                    onChange={(e) => enableFilter(header.id, header.column, e.target.value)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    placeholder="Suche..."
                                                />
                                            )}
                                        </span>
                                    </th>
                                    );
                                })}
                            </tr>
                            </thead>
                            <tbody>
                            {data?.map((d, index) => (
                                <tr key={`wv-${d.FP_ID}-${index}`} className={`${getRowColor(d)} rounded bg-opacity-30 my-2`} style={{fontSize: "14px"}}>
                                    <td className="px-1 py-2 text-center">{getStatusIcon(d)}</td>
                                    <td className='p-1 text-left'>
                                        {d.wv_datum ? format(new Date(d.wv_datum), 'dd.MM.yyyy') : ''}
                                    </td>
                                    <td className='p-1 text-left' style={{
                                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
                                    }}>
                                        <a
                                            href={`/firmenprojekte/${d.module}/${d.FP_ID}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-mainBlue flex-shrink-0 ml-2 hover:underline"
                                            title="Details anzeigen"
                                        >{d.firma}</a>
                                    </td>
                                    <td className='p-1 text-left' style={{
                                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
                                    }}>
                                        {d.berater}
                                    </td>
                                    <td className='p-1 text-left'>
                                        {d.erfasst_am ? format(new Date(d.erfasst_am), 'dd.MM.yyyy') : ''}
                                    </td>
                                    <td className='p-1 text-left' style={{
                                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
                                    }}>
                                        {d.erfasst_von}
                                    </td>
                                    <td className='p-1 text-left' style={{
                                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "left"
                                    }}>
                                        <div className="flex items-center justify-between">
                                            <span className="truncate">{d.bemerkung}</span>
                                            <a
                                                href={`/firmenprojekte/${d.module}/${d.FP_ID}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-mainBlue flex-shrink-0 ml-2"
                                                title="Details anzeigen"
                                            >
                                                <ArrowTopRightOnSquareIcon className="h-5 w-5"/>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                            {noDataFound && <h3 className='centerItemsAbsolute'>Keine Daten gefunden</h3>}
                        </table>
                    </div>
                </>}
                <div className={`grid grid-cols-3 items-center ${loading && 'opacity-0'}`}>
                    <div className="col-span-1 flex gap-10">
                        <p className={`${(data?.length === 0) && 'hideDiv'} mr-2 text-sm text-grey mt-11`}>
                            {pageWvHistory === 1 ? pageWvHistory : (1 + (Number(rows) * pageWvHistory)) - Number(rows)} bis {(data?.length < Number(rows)) ? data.length + Number(rows) < total ? data.length + (Number(rows) * pageWvHistory) - Number(rows) : total : (Number(rows) + (Number(rows) * pageWvHistory)) - Number(rows)} von {total} Einträge
                        </p>
                        <h2 className={`${(data?.length === 0) && 'hideDiv'}  text-sm text-grey mt-11`}>
                            Einträge anzeigen:
                            <span>
                            <select onChange={setPageStates} className={` bg-transparent text-mainBlue`}>
                                <option value={'10'}>{10}</option>
                                <option value={'25'}>{25}</option>
                                <option value={'10000'}>Alle</option>
                            </select>
                        </span>
                        </h2>
                    </div>
                    <div className="flex justify-center mt-10">
                        {data.length > 0 && <Pagination
                            className="pagination-bar"
                            currentPage={pageWvHistory}
                            totalCount={total}
                            pageSize={PageSize}
                            onPageChange={pageNo => dispatch({
                                type: "SET_PAGE_WVHISTORY", item: pageNo
                            })}
                        />}
                    </div>
                </div>
            </div>
        </div>);
};

export default MailHistory
